/**
 * @generated SignedSource<<fecf2be273e384cec626ad3613dca11f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PriceDisplayVariant_displayPrice$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"IncludedLabels_displayPrice" | "ItemPrice_displayPrice" | "useItemPriceData_displayPrice" | "useShowIncludedLabelsInline_displayPrice">;
  readonly " $fragmentType": "PriceDisplayVariant_displayPrice";
}>;
export type PriceDisplayVariant_displayPrice$key = ReadonlyArray<{
  readonly " $data"?: PriceDisplayVariant_displayPrice$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplayVariant_displayPrice">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PriceDisplayVariant_displayPrice",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemPrice_displayPrice"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_displayPrice"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IncludedLabels_displayPrice"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowIncludedLabelsInline_displayPrice"
    }
  ],
  "type": "ItemDisplayPriceType",
  "abstractKey": null
};

(node as any).hash = "c44c7316522e3b7c3a63d7a1283028e1";

export default node;
